// src/constants/contractInfo.js
import fundAbi from "../MainXXFund.json"; // Base fund implementation
import governanceAbi from "../YILDXGovernance.json"; // Governance contract
import fundWithGovernanceAbi from "../MainXXFundWithGovernance.json"; // Fund with governance integration
import yildxTokenAbi from "../YILDXToken.json"; // YILDX governance token

// Contract addresses from your deployment
// You need to replace these with the actual deployed addresses
export const FUND_CONTRACT_ADDRESS = "0x0C2bC81d9A2Fa463Da57919e616d92eC90e90674"; // MainXXFundWithGovernance address
export const GOVERNANCE_CONTRACT_ADDRESS = "0x1d9142dccd34CAed751B8a0D2AaE889085A163A8"; // YILDXGovernance address
export const YILDX_TOKEN_ADDRESS = "0xA009435b2CE81B07E85FE9Fb6ccAd87a5659d6De"; // YILDX Regular Token address

// Export the correct ABIs
// We should use the MainXXFundWithGovernance ABI for the fund interface
export const FUND_ABI = fundWithGovernanceAbi.abi;
export const GOVERNANCE_ABI = governanceAbi.abi;
export const YILDX_TOKEN_ABI = yildxTokenAbi.abi;

// For backward compatibility (if your code still uses these)
export const CONTRACT_ADDRESS = FUND_CONTRACT_ADDRESS;
export const ABI = FUND_ABI;

// Other useful constants for the application
export const MIN_TOKENS_TO_VOTE = "100"; // 100 YILDX tokens required to create proposals
export const MIN_TOKENS_TO_VOTE_BN = "100000000000000000000"; // 100 * (10^18) in wei